import { mapEnumToOptions } from '@abp/ng.core';

export enum ProjectVesselStatus {
  Expected = 0,
  Anchored = 1,
  InPort = 2,
  Sailed = 3,
}

export const projectVesselStatusOptions = mapEnumToOptions(ProjectVesselStatus);
